export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13373.5a415f7b.jpg";